module.exports = __webpack_public_path__ + "assets/img/b4cda4768a933cb759620d27f01a143e.svg";